module.exports = __webpack_public_path__ + "static/about-us-2d7509c45e68d9fa0b13817f50072656.jpg";